import draggable from 'vuedraggable'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('draggable', draggable)
})

// Nuxt の型生成は plugins 経由のグローバル登録を追跡しないため、上で
// 登録した <draggable> は GlobalComponents に含まれない。結果、
// vueCompilerOptions.checkUnknownComponents 有効化時に template で型エラー
// となるため、ここで GlobalComponents に型を補って整合させる。
declare module '@vue/runtime-core' {
  interface GlobalComponents {
    draggable: typeof draggable
  }
}
